export const ContainerBox = {
    backgroundColor: "inherit",
    flex: "1",
    display: { xs: "none", md: "block" },
  };


  export const ContainerBoxlogoandtypo = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "15px",
  };

  export const ButtonStyleForpishKhan = {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    columnGap: "10px",
    color: "white",
    fontSize: "18px",
    backgroundColor: "green",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#006a25",
    },
  };

  export  const ButtonStyleForTicketAndmyCourse = {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    columnGap: "10px",
    color: "black",
    fontSize: "18px",
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  };

  export   const ButtonStyleForExit = {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    columnGap: "10px",
    color: "black",
    fontSize: "20px",
    marginTop: "15px",
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  };